"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateObjectBounds = exports.updateObjectShadow = exports.setObjectShadow = exports.angleToPoint = void 0;
var fabric_1 = require("fabric");
var lodash_1 = require("lodash");
function angleToPoint(angle, sx, sy) {
    while (angle < 0)
        angle += 360;
    angle %= 360;
    var a = sy, b = a + sx, c = b + sy, p = (sx + sy) * 2, rp = p * 0.00277, pp = Math.round((angle * rp + (sy >> 1)) % p);
    if (pp <= a)
        return { x: 0, y: sy - pp };
    if (pp <= b)
        return { y: 0, x: pp - a };
    if (pp <= c)
        return { x: sx, y: pp - b };
    return { y: sy, x: sx - (pp - c) };
}
exports.angleToPoint = angleToPoint;
var setObjectGradient = function (object, angle, colors) {
    var odx = object.width >> 1;
    var ody = object.height >> 1;
    var startPoint = angleToPoint(angle, object.width, object.height);
    var endPoint = {
        x: object.width - startPoint.x,
        y: object.height - startPoint.y,
    };
    object.set("fill", new fabric_1.fabric.Gradient({
        type: "linear",
        coords: {
            x1: startPoint.x - odx,
            y1: startPoint.y - ody,
            x2: endPoint.x - odx,
            y2: endPoint.y - ody,
        },
        colorStops: [
            { offset: 0, color: colors[0] },
            { offset: 1, color: colors[1] },
        ],
    }));
};
var setObjectShadow = function (object, options) {
    if (options.enabled) {
        object.set({
            shadow: new fabric_1.fabric.Shadow(options),
        });
    }
    else {
        object.set({
            shadow: null,
        });
    }
};
exports.setObjectShadow = setObjectShadow;
var updateObjectShadow = function (object, options) {
    if (options) {
        object.set({
            shadow: new fabric_1.fabric.Shadow(options),
        });
    }
    else {
        object.set({
            shadow: null,
        });
    }
};
exports.updateObjectShadow = updateObjectShadow;
var updateObjectBounds = function (element, options) {
    var top = element.top, left = element.left, width = element.width, height = element.height;
    if ((0, lodash_1.isNaN)(top) || (0, lodash_1.isNaN)(left)) {
        element.set({
            top: options.top + options.height / 2 - height / 2,
            left: options.left + options.width / 2 - width / 2,
        });
    }
};
exports.updateObjectBounds = updateObjectBounds;
exports.default = setObjectGradient;
//# sourceMappingURL=fabric.js.map